// Currency conversion service with geolocation support
import { detectUserCountry } from './geolocation';

// Exchange rates API - using a free service for real-time rates
const EXCHANGE_RATES_API = 'https://api.exchangerate-api.com/v4/latest/USD';

// Currency mapping by country code
const COUNTRY_CURRENCY_MAP = {
  'US': 'USD',
  'CA': 'CAD',
  'GB': 'GBP',
  'AU': 'AUD',
  'NZ': 'NZD',
  'JP': 'JPY',
  'KR': 'KRW',
  'CN': 'CNY',
  'IN': 'INR',
  'SG': 'SGD',
  'HK': 'HKD',
  'MX': 'MXN',
  'BR': 'BRL',
  'AR': 'ARS',
  'CL': 'CLP',
  'CO': 'COP',
  'PE': 'PEN',
  'UY': 'UYU',
  'PY': 'PYG',
  'EC': 'USD',
  'BO': 'BOB',
  'VE': 'VES',
  'GY': 'GYD',
  'SR': 'SRD',
  'FR': 'EUR',
  'DE': 'EUR',
  'IT': 'EUR',
  'ES': 'EUR',
  'PT': 'EUR',
  'NL': 'EUR',
  'BE': 'EUR',
  'AT': 'EUR',
  'FI': 'EUR',
  'IE': 'EUR',
  'GR': 'EUR',
  'LU': 'EUR',
  'MT': 'EUR',
  'CY': 'EUR',
  'SK': 'EUR',
  'SI': 'EUR',
  'EE': 'EUR',
  'LV': 'EUR',
  'LT': 'EUR',
  'CH': 'CHF',
  'NO': 'NOK',
  'SE': 'SEK',
  'DK': 'DKK',
  'IS': 'ISK',
  'PL': 'PLN',
  'CZ': 'CZK',
  'HU': 'HUF',
  'RO': 'RON',
  'BG': 'BGN',
  'HR': 'HRK',
  'RS': 'RSD',
  'BA': 'BAM',
  'MK': 'MKD',
  'AL': 'ALL',
  'ME': 'EUR',
  'XK': 'EUR',
  'MD': 'MDL',
  'UA': 'UAH',
  'BY': 'BYN',
  'RU': 'RUB',
  'GE': 'GEL',
  'AM': 'AMD',
  'AZ': 'AZN',
  'KZ': 'KZT',
  'UZ': 'UZS',
  'KG': 'KGS',
  'TJ': 'TJS',
  'TM': 'TMT',
  'AF': 'AFN',
  'PK': 'PKR',
  'BD': 'BDT',
  'LK': 'LKR',
  'MV': 'MVR',
  'NP': 'NPR',
  'BT': 'BTN',
  'MM': 'MMK',
  'TH': 'THB',
  'LA': 'LAK',
  'KH': 'KHR',
  'VN': 'VND',
  'MY': 'MYR',
  'BN': 'BND',
  'ID': 'IDR',
  'PH': 'PHP',
  'TW': 'TWD',
  'MN': 'MNT',
  'TR': 'TRY',
  'CY': 'EUR',
  'SY': 'SYP',
  'LB': 'LBP',
  'JO': 'JOD',
  'IQ': 'IQD',
  'IR': 'IRR',
  'IL': 'ILS',
  'PS': 'ILS',
  'SA': 'SAR',
  'AE': 'AED',
  'QA': 'QAR',
  'BH': 'BHD',
  'KW': 'KWD',
  'OM': 'OMR',
  'YE': 'YER',
  'EG': 'EGP',
  'LY': 'LYD',
  'TN': 'TND',
  'DZ': 'DZD',
  'MA': 'MAD',
  'EH': 'MAD',
  'MR': 'MRU',
  'ML': 'XOF',
  'BF': 'XOF',
  'NE': 'XOF',
  'CI': 'XOF',
  'GH': 'GHS',
  'TG': 'XOF',
  'BJ': 'XOF',
  'NG': 'NGN',
  'CM': 'XAF',
  'TD': 'XAF',
  'CF': 'XAF',
  'CG': 'XAF',
  'GA': 'XAF',
  'GQ': 'XAF',
  'AO': 'AOA',
  'ZM': 'ZMW',
  'ZW': 'ZWL',
  'BW': 'BWP',
  'NA': 'NAD',
  'ZA': 'ZAR',
  'LS': 'LSL',
  'SZ': 'SZL',
  'MZ': 'MZN',
  'MW': 'MWK',
  'MG': 'MGA',
  'MU': 'MUR',
  'SC': 'SCR',
  'KM': 'KMF',
  'DJ': 'DJF',
  'SO': 'SOS',
  'ET': 'ETB',
  'ER': 'ERN',
  'SD': 'SDG',
  'SS': 'SSP',
  'UG': 'UGX',
  'KE': 'KES',
  'TZ': 'TZS',
  'RW': 'RWF',
  'BI': 'BIF',
  'CD': 'CDF',
  'ST': 'STN',
  'CV': 'CVE',
  'SN': 'XOF',
  'GM': 'GMD',
  'GW': 'XOF',
  'GN': 'GNF',
  'SL': 'SLL',
  'LR': 'LRD'
};

// Currency symbols
export const CURRENCY_SYMBOLS = {
  'USD': '$',
  'EUR': '€',
  'GBP': '£',
  'JPY': '¥',
  'CNY': '¥',
  'KRW': '₩',
  'INR': '₹',
  'CAD': 'C$',
  'AUD': 'A$',
  'NZD': 'NZ$',
  'CHF': 'CHF',
  'SEK': 'kr',
  'NOK': 'kr',
  'DKK': 'kr',
  'PLN': 'zł',
  'CZK': 'Kč',
  'HUF': 'Ft',
  'RUB': '₽',
  'BRL': 'R$',
  'MXN': '$',
  'ARS': '$',
  'CLP': '$',
  'COP': '$',
  'PEN': 'S/',
  'TRY': '₺',
  'THB': '฿',
  'SGD': 'S$',
  'HKD': 'HK$',
  'MYR': 'RM',
  'IDR': 'Rp',
  'PHP': '₱',
  'VND': '₫',
  'TWD': 'NT$',
  'SAR': 'SR',
  'AED': 'AED',
  'EGP': 'E£',
  'ZAR': 'R',
  'NGN': '₦',
  'GHS': 'GH₵',
  'KES': 'KSh',
  'UGX': 'USh',
  'TZS': 'TSh',
  'MAD': 'MAD',
  'TND': 'TND',
  'DZD': 'DZD',
  'BGN': 'лв',
  'RON': 'lei',
  'HRK': 'kn',
  'RSD': 'дин',
  'MKD': 'ден',
  'ALL': 'L'
};

// Default currency if detection fails
const DEFAULT_CURRENCY = 'USD';

// Cache for exchange rates
let exchangeRatesCache = null;
let lastFetchTime = null;
const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

/**
 * Fetch current exchange rates from API
 */
const fetchExchangeRates = async () => {
  try {
    const response = await fetch(EXCHANGE_RATES_API);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    
    if (data.rates) {
      exchangeRatesCache = data.rates;
      lastFetchTime = Date.now();
      console.log('✅ Exchange rates fetched successfully');
      return data.rates;
    } else {
      throw new Error('Invalid exchange rates response');
    }
  } catch (error) {
    console.error('❌ Error fetching exchange rates:', error);
    
    // Fallback to cached rates if available
    if (exchangeRatesCache) {
      console.log('Using cached exchange rates');
      return exchangeRatesCache;
    }
    
    // Ultimate fallback - basic rates
    return {
      'USD': 1,
      'EUR': 0.85,
      'GBP': 0.73,
      'CAD': 1.35,
      'AUD': 1.45,
      'JPY': 110,
      'CNY': 6.45,
      'INR': 74,
      'BRL': 5.2,
      'MXN': 20,
      'RUB': 75,
      'KRW': 1180,
      'CHF': 0.92,
      'SEK': 8.6,
      'NOK': 8.8,
      'DKK': 6.4,
      'PLN': 3.9,
      'CZK': 21.5,
      'HUF': 295,
      'TRY': 8.5,
      'THB': 33,
      'SGD': 1.35,
      'HKD': 7.8,
      'MYR': 4.2,
      'IDR': 14300,
      'PHP': 50,
      'VND': 23000,
      'TWD': 28,
      'SAR': 3.75,
      'AED': 3.67,
      'EGP': 15.7,
      'ZAR': 14.3,
      'NGN': 410,
      'GHS': 6.1,
      'KES': 108,
      'UGX': 3550,
      'TZS': 2320,
      'MAD': 9.0,
      'TND': 2.8,
      'DZD': 134
    };
  }
};

/**
 * Get exchange rates (with caching)
 */
export const getExchangeRates = async () => {
  // Check if we have cached rates and they're still fresh
  if (exchangeRatesCache && lastFetchTime && (Date.now() - lastFetchTime) < CACHE_DURATION) {
    return exchangeRatesCache;
  }
  
  return await fetchExchangeRates();
};

/**
 * Detect user's currency based on geolocation
 */
export const detectUserCurrency = async () => {
  try {
    const countryCode = await detectUserCountry();
    const currency = COUNTRY_CURRENCY_MAP[countryCode] || DEFAULT_CURRENCY;
    
    console.log(`🌍 Detected currency: ${currency} for country: ${countryCode}`);
    return currency;
  } catch (error) {
    console.error('Error detecting user currency:', error);
    return DEFAULT_CURRENCY;
  }
};

/**
 * Convert amount from USD to target currency
 */
export const convertFromUSD = async (amountInUSD, targetCurrency) => {
  if (targetCurrency === 'USD') {
    return amountInUSD;
  }
  
  try {
    const rates = await getExchangeRates();
    const rate = rates[targetCurrency];
    
    if (!rate) {
      console.warn(`No exchange rate found for ${targetCurrency}, using USD`);
      return amountInUSD;
    }
    
    const convertedAmount = amountInUSD * rate;
    console.log(`💱 Converted $${amountInUSD} USD to ${convertedAmount.toFixed(2)} ${targetCurrency}`);
    return convertedAmount;
  } catch (error) {
    console.error('Error converting currency:', error);
    return amountInUSD;
  }
};

/**
 * Convert amount from any currency to USD
 */
export const convertToUSD = async (amount, fromCurrency) => {
  if (fromCurrency === 'USD') {
    return amount;
  }
  
  try {
    const rates = await getExchangeRates();
    const rate = rates[fromCurrency];
    
    if (!rate) {
      console.warn(`No exchange rate found for ${fromCurrency}, treating as USD`);
      return amount;
    }
    
    const convertedAmount = amount / rate;
    console.log(`💱 Converted ${amount} ${fromCurrency} to $${convertedAmount.toFixed(2)} USD`);
    return convertedAmount;
  } catch (error) {
    console.error('Error converting currency:', error);
    return amount;
  }
};

/**
 * Convert amount from any currency to EUR
 */
export const convertToEUR = async (amount, fromCurrency) => {
  if (fromCurrency === 'EUR') {
    return amount;
  }
  
  try {
    const rates = await getExchangeRates();
    const eurRate = rates['EUR'];
    const fromRate = rates[fromCurrency];
    
    if (!eurRate) {
      console.warn(`No exchange rate found for EUR, treating as USD`);
      // If EUR rate not found, convert via USD
      const usdAmount = fromCurrency === 'USD' ? amount : (amount / (fromRate || 1));
      return usdAmount * 0.85; // Fallback EUR rate
    }
    
    if (!fromRate) {
      console.warn(`No exchange rate found for ${fromCurrency}, treating as USD`);
      return amount * eurRate;
    }
    
    // Convert: fromCurrency -> USD -> EUR
    const usdAmount = amount / fromRate;
    const eurAmount = usdAmount * eurRate;
    console.log(`💱 Converted ${amount} ${fromCurrency} to €${eurAmount.toFixed(2)} EUR`);
    return eurAmount;
  } catch (error) {
    console.error('Error converting currency to EUR:', error);
    return amount;
  }
};

/**
 * Format currency amount with appropriate symbol and formatting
 */
export const formatCurrency = (amount, currency, options = {}) => {
  const {
    showSymbol = true,
    decimals = 2,
    locale = 'en-US'
  } = options;
  
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  
  // Handle special formatting for certain currencies
  let formattedAmount;
  
  if (currency === 'JPY' || currency === 'KRW' || currency === 'VND' || currency === 'IDR') {
    // These currencies typically don't use decimal places
    formattedAmount = Math.round(amount).toLocaleString(locale);
  } else {
    formattedAmount = amount.toFixed(decimals);
  }
  
  if (showSymbol) {
    // For currencies that use symbol after amount
    if (currency === 'SEK' || currency === 'NOK' || currency === 'DKK') {
      return `${formattedAmount} ${symbol}`;
    }
    return `${symbol}${formattedAmount}`;
  }
  
  return formattedAmount;
};

/**
 * Get currency symbol for a given currency code
 */
export const getCurrencySymbol = (currency) => {
  return CURRENCY_SYMBOLS[currency] || currency;
};

/**
 * Check if payment method requires USD only (like Gumroad)
 */
export const isUSDOnlyPaymentMethod = (paymentMethod) => {
  const usdOnlyMethods = ['gumroad'];
  return usdOnlyMethods.includes(paymentMethod?.toLowerCase());
};

/**
 * Get supported currencies for a payment method
 */
export const getSupportedCurrencies = (paymentMethod) => {
  switch (paymentMethod?.toLowerCase()) {
    case 'gumroad':
      return ['USD'];
    case 'stripe':
    case 'rotation':
      return ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'BRL', 'MXN', 'SGD', 'HKD', 'MYR', 'INR', 'THB'];
    case 'wix':
      return ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'ILS', 'JPY', 'BRL', 'MXN'];
    case 'shopify':
      return ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY', 'CHF', 'SEK', 'NOK', 'DKK', 'PLN', 'CZK', 'HUF', 'BRL', 'MXN', 'SGD', 'HKD', 'MYR', 'INR', 'THB', 'NZD', 'ZAR'];
    case 'mypos':
      return ['USD', 'EUR', 'GBP', 'BGN', 'RON', 'CHF', 'PLN', 'CZK', 'HUF', 'HRK', 'RSD', 'MKD', 'ALL']; // myPOS supported currencies
    default:
      return ['USD'];
  }
};

/**
 * Calculate dual currency display for all payment methods
 */
export const calculateDualCurrencyDisplay = async (amountInUSD, userCurrency, paymentMethod) => {
  const isUSDOnly = isUSDOnlyPaymentMethod(paymentMethod);
  
  // If user currency is USD, no conversion needed
  if (userCurrency === 'USD') {
    return {
      displayCurrency: userCurrency,
      displayAmount: amountInUSD,
      showDualCurrency: false,
      usdAmount: amountInUSD,
      localAmount: amountInUSD,
      localCurrency: userCurrency
    };
  }
  
  // Convert USD to user's local currency
  const localAmount = await convertFromUSD(amountInUSD, userCurrency);
  
  if (isUSDOnly) {
    // For USD-only payment methods (like Gumroad), show dual currency
    return {
      displayCurrency: userCurrency,
      displayAmount: localAmount,
      showDualCurrency: true,
      usdAmount: amountInUSD,
      localAmount: localAmount,
      localCurrency: userCurrency,
      paymentCurrency: 'USD',
      paymentAmount: amountInUSD
    };
  } else {
    // For multi-currency payment methods (Shopify, Wix, Stripe), show converted amount
    return {
      displayCurrency: userCurrency,
      displayAmount: localAmount,
      showDualCurrency: false,
      usdAmount: amountInUSD,
      localAmount: localAmount,
      localCurrency: userCurrency,
      paymentCurrency: userCurrency,
      paymentAmount: localAmount
    };
  }
};

/**
 * Initialize currency service
 */
export const initializeCurrencyService = async () => {
  try {
    console.log('🚀 Initializing currency service...');
    
    // Pre-fetch exchange rates
    await getExchangeRates();
    
    // Detect user currency
    const userCurrency = await detectUserCurrency();
    
    console.log('✅ Currency service initialized successfully');
    return {
      success: true,
      userCurrency: userCurrency,
      exchangeRatesLoaded: !!exchangeRatesCache
    };
  } catch (error) {
    console.error('❌ Error initializing currency service:', error);
    return {
      success: false,
      userCurrency: DEFAULT_CURRENCY,
      exchangeRatesLoaded: false,
      error: error.message
    };
  }
}; 